import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, mergeProps as _mergeProps, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "header" }
const _hoisted_2 = {
  key: 0,
  class: "empty-area"
}
const _hoisted_3 = { class: "title" }
const _hoisted_4 = {
  key: 0,
  class: "info"
}
const _hoisted_5 = { class: "content" }
const _hoisted_6 = {
  key: 1,
  class: "footer"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Image = _resolveComponent("Image")!
  const _component_VueFinalModal = _resolveComponent("VueFinalModal")!

  return (_openBlock(), _createBlock(_component_VueFinalModal, _mergeProps(_ctx.$attrs, {
    class: "content-modal",
    "lock-scroll": !_ctx.hideOverlay,
    "content-class": `content-modal-content  ${_ctx.modalSizeClass}`,
    "overlay-class": _ctx.hideOverlay ? 'content-modal-hide-overlay' : '',
    "teleport-to": _ctx.teleportTo,
    background: _ctx.backgroundInteractive,
    "click-to-close": false
  }), {
    default: _withCtx(({ close }) => [
      _createElementVNode("div", _hoisted_1, [
        (_ctx.useCloseButton)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2))
          : _createCommentVNode("", true),
        _createElementVNode("h1", _hoisted_3, [
          _renderSlot(_ctx.$slots, "title")
        ]),
        (_ctx.useCloseButton)
          ? (_openBlock(), _createBlock(_component_Image, {
              key: 1,
              class: "close-button clickable",
              src: "svg/ic_cancel",
              extension: "svg",
              onClick: ($event: any) => (_ctx.onClose(close))
            }, null, 8, ["onClick"]))
          : _createCommentVNode("", true)
      ]),
      (_ctx.$slots.info)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _renderSlot(_ctx.$slots, "info")
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_5, [
        _renderSlot(_ctx.$slots, "content")
      ]),
      (_ctx.$slots.footer)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _renderSlot(_ctx.$slots, "footer")
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 3
  }, 16, ["lock-scroll", "content-class", "overlay-class", "teleport-to", "background"]))
}